module.exports = __webpack_public_path__ + "static/media/train.10074133.svg";